
// Use lowercase and tolower any descriptions when finding match
const categoryKeywords = {
   // --- Add your keywords below ---
   'Education': ['school', 'ncs', 'college', 'university', 'student loan', 'tuition', 'coursera', 'udemy', 'bookstore', 'tutor'],
   'Entertainment': ['stubhub', 'movie', 'cinema', 'concert', 'tickets', 'spotify', 'netflix', 'hulu', 'disney+', 'steam', 'gaming', 'bar', 'event'],
   'Medical': ['doctor', 'hospital', 'pharmacy', 'cvs', 'walgreens', 'dentist', 'clinic', 'healthcare', 'copay', 'prescription'],
   'Eating out': ['restaurant', 'cafe', 'dining', 'lunch', 'dinner', 'brunch', 'starbucks', 'mcdonald\'s', 'grubhub', 'doordash', 'uber eats', 'coffee', 'someburros', 'chik-fil-a', 'chick-fil-a', 'in-n-out', 'barros', 'wendys', 'salad and go', 'dairy queen', 'starbucks', 'sonic', 'el encanto dos', 'dunkin'],
   'Amazon': ['amazon', 'amzn', 'aws'],
   'Household': ['home depot', 'lowes', 'ikea', 'hardware', 'cleaning', 'furniture', 'appliances', 'ace hardware', 'walmart home'],
   'Vehicle': ['mechanic', 'auto repair', 'car wash', 'jiffy lube', 'oil change', 'dmv', 'registration', 'parking'],
   'Charity': ['donation', 'charity', 'nonprofit', 'unicef', 'red cross'],
   'Clothing': ['gap', 'old navy', 'macys', 'nordstrom', 'clothes', 'shoes', 'apparel', 'tj maxx', 'ross'],
   'Pet': ['petsmart', 'petco', 'vet', 'veterinarian', 'chewy', 'pet food', 'pet'],
   'Target': ['target'],
   'Gas': ['gas', 'fuel', 'shell', 'chevron', 'mobil', 'exxon', 'circle k', 'qt', ' Maverik', 'arco'], // Added common gas station names
   'Grocery': ['safeway', 'kroger', 'albertsons', 'trader joes', 'whole foods', 'grocery', 'supermarket', 'costco', 'sams club', 'sprouts', 'frys', 'bashas', 'aj\'s'], // Added common grocery store names
   'Bills': ['rent', 'mortgage', 'utility', 'water', 'electric', 'internet', 'comcast', 'verizon', 'at&t', 'phone', 'insurance', 'loan payment', 'credit card payment', 'spotify', 'netflix', 'hulu'], // Can overlap, consider order/specificity
   // --- Add more categories and keywords as needed ---
};

// Default other category id
const defaultOtherCategory = "8b7df87a-4ea3-4511-b84e-6b7005cfb773";

function getCategoryIdByDescription(description, categories) {
   if (!description || !categories || categories.length === 0) {
      return defaultOtherCategory; // Or handle error appropriately
   }

   const lowerCaseDescription = description.toLowerCase();

   // Iterate through the provided categories
   for (const category of categories) {
      const categoryName = category.category;
      const keywords = categoryKeywords[categoryName]; // Get keywords using the category name

      // Check if we have keywords defined for this category and it's not 'Other'
      if (keywords && keywords.length > 0) {
         // Check if any keyword for this category exists in the description
         for (const keyword of keywords) {
            // Using includes() for simple substring matching.
            // Ensure keyword is lowercase (should be from categoryKeywords definition)
            if (lowerCaseDescription.includes(keyword)) {
               return category.id; // Match found! Return this category's ID.
            }
         }
      }
   }

   // If no keywords matched after checking all categories, return the default ID
   return defaultOtherCategory;
}

// Export the function for use in other modules
export { getCategoryIdByDescription };